import React,{ useRef, useState } from 'react';
import axios from 'axios';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import LinearProgress from '@mui/material/LinearProgress';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Papa from 'papaparse';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

const materialTheme = createTheme(({
    // set default for now
}));


const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
      position: 'fixed',
      backgroundColor: '#ffff00',
      color: 'black'
  },
  title: {
      marginLeft: theme.spacing(2),
      flex: 1,
  },
  csvInput: {
    display: 'none',
  },
  fullWidth: {
    width: "100%"
  },
}));

function CreateSalesmanTargetViaCSVDialog(props) {
  const selectFileElement = useRef()
  const classes = useStyles();

  const [csvUploadPercent, setCsvUploadPercent] = useState(0);
  const [uploadStatusArray,setUploadStatusArray] = useState([])
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [isDownloadTemplateDisabled, setIsDownloadTemplateDisabled] = useState(false);

  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      
    return formData;
  }, new FormData());

  const onInputChange = async (event) =>{
    let file = event.target.files;
    await processCSV(file);
  };

  const Transition = React.forwardRef(function Transition(props, ref) {
      return <Slide direction="up" ref={ref} {...props} />;
  });

  const downloadSalesmanTemplates = (salesmen) => {
    setIsDownloadTemplateDisabled(true);
    let totalCount = salesmen.length;
    if(totalCount < 1){
      alert('No salesmen to export')
      return;
    } 
    totalCount = Math.ceil(salesmen.length / 10);
    const dividedArray = divideArrayByChunkSize(salesmen, 10);

    executeDownloadSalesmanCSV(0, totalCount, dividedArray, '')
  }

  function divideArrayByChunkSize(arr, chunkSize) {
    const dividedArray = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      dividedArray.push(arr.slice(i, i + chunkSize));
    }
    return dividedArray;
  }

  const executeDownloadSalesmanCSV = async (index, totalCount, dividedArray, csv_data) => {
    if(index < totalCount){
      const options = {
        method: 'POST',
        url: '/TransactiSalesman/getSalesmanTargets.json',
        data: objectToFormData({salesmen : JSON.stringify(dividedArray[index])})
      }

      await axios(options)
      .then(res => {
          let formattedData = res.data;
          for(let i in formattedData){
            csv_data += formattedData[i]['username'] + ',';
            csv_data += formattedData[i]['JAN'] + ',';
            csv_data += formattedData[i]['FEB'] + ',';
            csv_data += formattedData[i]['MAR'] + ',';
            csv_data += formattedData[i]['APR'] + ',';
            csv_data += formattedData[i]['MAY'] + ',';
            csv_data += formattedData[i]['JUN'] + ',';
            csv_data += formattedData[i]['JUL'] + ',';
            csv_data += formattedData[i]['AUG'] + ',';
            csv_data += formattedData[i]['SEP'] + ',';
            csv_data += formattedData[i]['OCT'] + ',';
            csv_data += formattedData[i]['NOV'] + ',';
            csv_data += formattedData[i]['DEC'] + ',\n';
          }
          executeDownloadSalesmanCSV(index+1, totalCount, dividedArray, csv_data);
      })
    }else{
      let header = 'Username*,JAN,FEB,MAR,APR,MAY,JUN,JUL,AUG,SEP,OCT,NOV,DEC';
      let csv = header+'\n'+csv_data;
      const url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Seller Sales Target Template.csv`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      setIsDownloadTemplateDisabled(false)
    }
  }

  function chunkUploadData(results){
    let chunkedData = [];
    let dataArray = [];
    for(let i = 0; i < results.length; i++){
      if(dataArray.length === 10){
        chunkedData.push(dataArray);
        dataArray = [];
      }

      dataArray.push(results[i]);
   
      if ( i === results.length - 1 )
      {
        chunkedData.push(dataArray);
        dataArray = [];
      }
    }
    return chunkedData;
  } 

  function processCSV(csvFile){
    let file = csvFile[0];
    let headersChecked = false; 
    if(file !== undefined && file.type === "text/csv"){
      Papa.parse(file, {
        header: true,
        skipEmptyLines : true,
        complete: function(results) {
          if(!headersChecked){
            let keys = [];
            Object.keys(results.data[0]).forEach(value =>{
              keys.push(value);
            });

            if(keys.includes('Username*') && keys.includes('JAN') && keys.includes('FEB') 
            && keys.includes('MAR') && keys.includes('APR') && keys.includes('MAY') && keys.includes('JUN')  
            && keys.includes('JUN') && keys.includes('JUL') && keys.includes('AUG') && keys.includes('OCT')
            && keys.includes('SEP') && keys.includes('NOV') && keys.includes('DEC')) {
                headersChecked = true;
            } else{
                alert('File Error. Please Check your headers');
            }
          }if(headersChecked){
            let chunkedData = chunkUploadData(results.data);
            let totalData = Math.ceil(results.data.length / 10);
            if(chunkedData.length > 0){
              setShowUploadDialog(true);
              insertRecords(0,chunkedData,totalData);
            }else{
              alert('No data to upload');
            }
          }
        }
      });
    }else{
      alert('File error. Please check your file or if a file was selected.');
    }
  }

  async function insertRecords(index, chunkedData, totalData) {
    let percent = (index / totalData) * 100;
    setCsvUploadPercent(percent);
  
    if (index < chunkedData.length) {
      try {
        const res = await axios({
          method: 'POST',
          url: '/TransactiSalesman/uploadSalesmanTargets.json',
          data: objectToFormData({ index: index, data: JSON.stringify(chunkedData[index]) }),
        });
  
        let res_status = res.data.result;
        setUploadStatusArray((uploadStatusArray) => [...uploadStatusArray, ...res_status]);
  
        insertRecords(index + 1, chunkedData, totalData);
      } catch (error) {
        console.error('Error uploading data:', error);
      }
    } else {
      alert('Seller Targets Upload Finished');
      closeUploadStatusDialog()
    }
  }

  function uploadStatusDialog(){
    
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showUploadDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>Upload Salesman Targets</DialogTitle>
        <DialogContent>
          <LinearProgress sx={{height: 10}} variant="determinate" value={csvUploadPercent} />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="status_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left"><b>Line</b></TableCell>
                  <TableCell><b>Message</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadStatusArray.map((value, index)=> (
                    <TableRow key={index}>  
                      <TableCell align="left" component="th" scope="row"><b>{index+1}</b></TableCell>
                      <TableCell>{value}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{closeUploadStatusDialog()}} color="primary" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  const closeUploadStatusDialog = () => {
    setShowUploadDialog(false)
    props.setShowCreateSalesmanTargetViaCSV(false)
  }
    
  function mainBody(){
      return(
        <React.Fragment>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Button onClick={() => {downloadSalesmanTemplates(props.salesmen)}} 
                sx={{width:"100%"}} 
                variant="contained" 
                color="secondary"
                disabled={isDownloadTemplateDisabled} 
                >Download CSV Template File</Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                    <input
                        accept="*"
                          ref={selectFileElement}
                          className={classes.csvInput}
                          id="contained-button-file"
                          multiple
                          type="file"
                          onChange={onInputChange}
                      />
                      <label >
                          <Button 
                              style={{width:'100%'}}
                              variant="contained" 
                              color="secondary" 
                              component="span"
                              onClick={()=>{
                                    selectFileElement.current.click()
                              }}
                              >
                              Select File
                          </Button>
                      </label>
                </Grid>
              
              </Grid>
        </React.Fragment>
      )
    }

    return (
        <div>
           <Dialog fullScreen open={props.showCreateSalesmanTargetViaCSV} onClose={()=>{props.setShowCreateSalesmanTargetViaCSV(false)}} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{props.setShowCreateSalesmanTargetViaCSV(false)}}
                        aria-label="close"
                        size="large">
                        <CloseIcon />
                        </IconButton>
                        <Typography variant="h7" className={classes.title}>
                        Upload Salesmen Targets Via CSV
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className={classes.appBarSpacer}></div>
                <div style={{padding:'.5rem'}}>
                { mainBody()}
                </div>
                <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                <ThemeProvider theme={materialTheme}> {uploadStatusDialog()}</ThemeProvider>
                </ThemeProvider>
                </StyledEngineProvider>
            </Dialog>
        </div>
    );
}

export default CreateSalesmanTargetViaCSVDialog